import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_RO.json';
import exercises from './FITNESS_EXERCISES_RO.json';
import recipes from './FITNESS_RECIPES_RO.json';

export const FITNESS_DATA_RO: ServiceData = {
  articles,
  exercises,
  recipes,
};
